import orderBy from 'lodash/orderBy';

import {SankeyNode} from './sankey-node';
import {SankeyNodeType, SankeyNodeTypePriority} from './types';
import {SerializedSankeyStep} from './serialized';

export enum SankeyStepType {
  Anchor = `ANCHOR`,
  Regular = `REGULAR`,
}

export class SankeyStep {
  public nodes: SankeyNode[];
  public step: number;
  public type: SankeyStepType;

  constructor({nodes, step}: SerializedSankeyStep) {
    this.nodes = nodes.map((node) => new SankeyNode({...node, step: node.step || step}));
    this.step = step;

    this.sortNodes();
    this.fillNodeIndeces();

    const isFirstNodeAnchor = this.nodes[0] && this.nodes[0].type === SankeyNodeType.Anchor;
    this.type = isFirstNodeAnchor ? SankeyStepType.Anchor : SankeyStepType.Regular;
  }

  get isAnchor(): boolean {
    return this.type === SankeyStepType.Anchor;
  }

  get weight(): number {
    return this.nodes.reduce((sum, node) => sum + node.totalCount, 0);
  }

  private fillNodeIndeces() {
    this.nodes.forEach((node, index) => (node.index = index));
  }

  private sortNodes(): void {
    this.nodes = orderBy(
      this.nodes,
      [
        // "Dropoff" and "Other events" nodes are last
        ({type}) => SankeyNodeTypePriority[type],
        // nodes with greatest weight come first
        `totalCount`,
        // break count ties by sorting event name
        `eventString`,
      ],
      [`desc`, `desc`, `asc`],
    );
  }
}
